import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.farm.info');
import { OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import moment from 'moment';

@Component({
    selector: 'wiz-portal-farm-info',
template: templateSource || '',
    styles: [``],
})
export class PortalFarmInfoComponent implements OnInit {

    @Input() farm_id!: string;
    @Input() farm!: any;

    @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
    @ViewChild('modalMessage') modalMessage: any;

    constructor(@Inject( Service    )         public service: Service    ) {}

    public role: string = '';
    public machines: any[] = [];
    public selectedMachine: any = null;

    public data: any = {
        files: []
    };

    public status = {
        upload: false,
        upload_process: 0
    };

    private telDebounce = 0;
    private faxDebounce = 0;


    public async ngOnInit() {

        await this.service.init();
        this.role = this.service.auth.session?.role || '';

        await this.loadFarm();

        if (this.role === 'user') {
            await this.loadMachines();
        }

        await this.service.render();
    }

    private showModal(message: string): Promise<boolean> {
        return this.modalMessage.open({ message });
    }


    private async loadFarm() {

        const res = await wiz.call("farminfo", {
            farm_id: this.farm_id
        });

        if (res?.code === 200 && res.data) {
            this.data = res.data;

            try {
                this.data.files = JSON.parse(this.data.files);
            } catch (e: any) {
                this.data.files = [];
            }

        } else {
            this.data = { files: [] };
        }
    }

    private async loadMachines() {

        const res = await wiz.call("machines", { farm_id: this.farm_id });

        if (res?.code === 200 && Array.isArray(res.data)) {

            this.machines = res.data.map((m: any) => {

                // meta
                try { m.meta = m.meta ? JSON.parse(m.meta) : {}; }
                catch (e: any) { m.meta = {}; }

                // machine_condition
                try { m.machine_condition = JSON.parse(m.machine_condition); }
                catch (e: any) { m.machine_condition = []; }

                // tray
                try { m.tray = JSON.parse(m.tray); }
                catch (e: any) { m.tray = []; }

                if (m.installed) {
                    m.installed = moment(m.installed).format('YYYY-MM-DD');
                }

                return m;
            });

            if (this.machines.length > 0) {
                this.selectedMachine = this.machines[0];
            }

        } else {
            this.machines = [];
            this.selectedMachine = null;
        }
    }

    public async selectMachine(item: any) {
        this.selectedMachine = item;
        await this.service.render();
    }

    public postal() {
        new daum.Postcode({
            oncomplete: (data) => {

                const addr =
                    data.userSelectedType === 'R'
                        ? data.roadAddress
                        : data.jibunAddress;

                this.data.postal = data.zonecode;
                this.data.address1 = addr;
                this.data.address2 = '';

                this.service.render();
            }
        }).open();
    }

    public async formatTel(tel: string) {
        const token = this.telDebounce = Date.now();
        await new Promise(r => setTimeout(r, 100));
        if (token !== this.telDebounce) return;

        if (tel) {
            this.data.tel = tel
                .replace(/[^0-9]/g, "")
                .replace(
                    /(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/,
                    "$1-$2-$3"
                )
                .replace("--", "-");

            await this.service.render();
        }
    }

    public async formatFax(fax: string) {
        const token = this.faxDebounce = Date.now();
        await new Promise(r => setTimeout(r, 100));
        if (token !== this.faxDebounce) return;

        if (fax) {
            this.data.fax = fax
                .replace(/[^0-9]/g, "")
                .replace(
                    /(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/,
                    "$1-$2-$3"
                )
                .replace("--", "-");

            await this.service.render();
        }
    }

    public upload() {

        const files = this.fileInput?.nativeElement.files;
        if (!files || files.length === 0) return;

        const formData = new FormData();
        formData.append("farm_id", this.data.id);

        for (let i = 0; i < files.length; i++) {
            formData.append("file[]", files[i]);
        }

        this.status.upload = true;
        this.status.upload_process = 0;

        const xhr = new XMLHttpRequest();

        xhr.upload.addEventListener("progress", (e) => {
            if (e.lengthComputable) {
                this.status.upload_process =
                    Math.round((e.loaded / e.total) * 10000) / 100;
                this.service.render();
            }
        });

        xhr.onreadystatechange = async () => {

            if (xhr.readyState === 4) {

                this.status.upload = false;

                if (xhr.status !== 200) return;

                try {
                    const res = JSON.parse(xhr.responseText);

                    if (res?.code === 200) {
                        res.data.forEach((f: any) =>
                            this.data.files.push(f)
                        );
                    }

                } catch (e: any) {}

                if (this.fileInput?.nativeElement) {
                    this.fileInput.nativeElement.value = '';
                }

                await this.service.render();
            }
        };

        xhr.open("POST", "/wiz/api/portal.farm.info/upload");
        xhr.send(formData);
    }

    public async deleteFile(file: any) {

        const res = await wiz.call("delete", file);

        if (res?.code === 200) {
            this.data.files =
                this.data.files.filter((f: any) => f !== file);

            await this.service.render();
        }
    }

    public async regist() {

        const payload = { ...this.data };
        payload.files = JSON.stringify(payload.files || []);

        const res = await wiz.call("regist_farm", payload);

        if (res?.code === 200) {

            await this.showModal("농장정보가 등록되었습니다.");
            this.data.id = res.data;

        } else {

            await this.showModal("농장정보 등록에 실패 했습니다.");
        }

        await this.service.render();
    }
}

export default PortalFarmInfoComponent;